import { render, staticRenderFns } from "./TransactionManualInsertComponent.vue?vue&type=template&id=2671efd5"
import script from "./TransactionManualInsertComponent.vue?vue&type=script&lang=js"
export * from "./TransactionManualInsertComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports